"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Subscriber_1 = require("rxjs/Subscriber");
function takeWhileInclusive(predicate) {
    return this.lift(new TakeWhileInclusiveOperator(predicate));
}
exports.takeWhileInclusive = takeWhileInclusive;
var TakeWhileInclusiveOperator = (function () {
    function TakeWhileInclusiveOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileInclusiveOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileInclusiveSubscriber(subscriber, this.predicate));
    };
    return TakeWhileInclusiveOperator;
}());
var TakeWhileInclusiveSubscriber = (function (_super) {
    __extends(TakeWhileInclusiveSubscriber, _super);
    function TakeWhileInclusiveSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.index = 0;
        return _this;
    }
    TakeWhileInclusiveSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (e) {
            this.destination.error(e);
            return;
        }
        if (Boolean(result)) {
            this.destination.next(value);
        }
        else {
            var destination = this.destination;
            destination.next(value);
            destination.complete();
        }
    };
    return TakeWhileInclusiveSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeWhileInclusive.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/rxjs-extra/operator/takeWhileInclusive.js
// module id = ../../../../rxjs-extra/operator/takeWhileInclusive.js
// module chunks = 5